import React, { useState, useEffect, useContext } from "react";
import {
  Typography,
  Input,
  Button,
  Dropdown,
  Menu,
  Icon,
  message,
  Tabs,
} from "antd";
// import "./index.less";

// Components
import FollowUpTable from "./FollowUpTable";
import { platformApi } from "../../../api";
import WrappedAdvancedFilter from "../../TransactionMasters/Quotations/AdvancedFilters";

const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;
const { TabPane } = Tabs;

function FollowUpHomePage() {

  const [limit, setLimit] = useState(10);
  const [dataSource, setData] = useState([]);
  const [spinning, setSpinning] = useState(false);
  const [search, setSearch] = useState({ searchString: "" });
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [filterData, setFilterData] = useState({});
  //const [tab, setTab] = useState(activeTabElement.tab || "ACTIVE")
  // const [activeKey, setActivekey] = useState(activeTabElement.key || 1)
  const [tab, setTab] = useState("ACTIVE");
  const [activeKey, setActivekey] = useState(1);
  const [filteropen, setFilteropen] = useState(false);
  const [shouldLoadData, setShouldLoadData] = useState(false);
  const [activeFollowUpTab, setActiveFollowupTab] = useState(null);

  // Restore state from localStorage on component mount
  useEffect(() => {
    const savedState = JSON.parse(localStorage.getItem("activeFollowUpTab"));
    if (savedState) {
      setTab(savedState.tab || "ACTIVE");
      setActivekey(savedState.key || 1);
      setPage(savedState.page || 1);
      setLimit(savedState.limit || 10);
      setSearch(savedState.search || { searchString: "" });
      setFilterData(savedState.filterData || {});
      setFilteropen(savedState.filteropen || false);
      setShouldLoadData(true);
    } else {
      setShouldLoadData(true);
    }

  }, []);

  const getMenu = () => {
    let size = count / 10 + (count % 10 ? 1 : 0);
    let menus = [];
    menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item
        onClick={() => {
          setLimit(menu), setPage(1);
        }}
        key={menu}
      >
        {menu}
      </Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;

  useEffect(() => {
    if (!shouldLoadData) return;

    const loadData = () => {
      setSpinning(true);
      let obj = {
        page: page,
        size: limit,
        filter: filterData,
        searchString: search.searchString,
        status: tab,
      };

      platformApi
        .post("/api/customer/unique/phone", obj)
        .then((result) => {
          setSpinning(false);
          const { data } = result;
          if (data.code === 200) {
            const { response } = data;
            if (response.code === 200) {
              setData(response.data.customers);
              setCount(response.data.count);
            } else {
              message.error("Unable to fetch Quotation", 2);
            }
          } else {
            message.error("Unable to fetch Quotation", 2);
          }
        })
        .catch((error) => {
          setSpinning(false);
          console.error("Error on Quotation : ", error);
          message.error("Unable to fetch Quotation", 2);
        });
    };

    loadData();
  }, [shouldLoadData, page, limit, search, filterData, tab]);

  // Save current state to localStorage whenever it changes
  useEffect(() => {
    setActiveFollowupTab({
      tab: tab,
      key: activeKey,
      page: page,
      limit: limit,
      search: search,
      filterData: filterData,
      filteropen: filteropen,
    });
  }, [tab, activeKey, page, limit, search, filterData, filteropen]);

  const handleTabChange = (activeKey) => {
    let newTab = "";
    switch (activeKey) {
      case "1":
        newTab = "ACTIVE";
        break;
      case "2":
        newTab = "BOOKED";
        break;
      case "3":
        newTab = "REJECTED";
        break;
      case "4":
        newTab = "ALL";
        break;
      default:
        newTab = "ALL";
    }

    if (tab !== newTab) {
      setTab(newTab);
    }

    setSearch({ searchString: "" });
    setPage(1);
    setActivekey(activeKey);
  };

  const collapseFilter = () => {
    if (filteropen) setFilterData({});
    filteropen ? setFilteropen(false) : setFilteropen(true);
  };

  return (
    <div>
      <div className="accessories-head">
        <Title style={{ width: "60%" }} level={4}>
          Follow-Ups [{count}]
          <span style={{ margin: ".5rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit} &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          style={{ width: "30%" }}
          placeholder="Search Quotations/Phone"
          onSearch={(event) => {
            let searches = { searchString: event };
            setPage(1);
            setSearch(searches);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearch({ searchString: "" });
              setPage(1);
            }
          }}
        />
        <div style={{ width: "12%", textAlign: "center" }}>
          <Button
            type="link"
            onClick={() => {
              collapseFilter();
            }}
          >
            {filteropen ? "Back" : "Advanced  Filters"}
          </Button>
        </div>

        {/* <div style={{ width: "12%", textAlign: "center" }}>
          <Button
            type="link"
            onClick={() => {
              collapseFilter()
            }}
          >
            {filteropen ? "Back" : "Advanced  Filters"}
          </Button>
        </div> */}
      </div>
      <WrappedAdvancedFilter
        filteropen={filteropen}
        setFilterData={setFilterData}
        filterData={filterData}
        isFollowUp={true}
      />
      {/* <WrappedAdvancedFilter
        filteropen={filteropen}
        searchName={search}
        setId={setFilter}
        setPageData={setPageData}
        setSearch={setSearch}
        setFilterData={setFilterData}
        setPage={setPage}
      /> */}
      <Tabs activeKey={String(activeKey)} onChange={handleTabChange}>
        <TabPane tab={<span>Quoted</span>} key="1">
          <FollowUpTable
            spinner={spinning}
            dataSource={dataSource || []}
            pagination={{
              onChange: (page) => {
                setPage(page);
              },
              pageSize: limit,
              total: count,
              current: page,
              showQuickJumper: true,
            }}
            activeFollowUpTab={activeFollowUpTab}
          />
        </TabPane>
        <TabPane tab={<span>Booked</span>} key="2">
          <FollowUpTable
            spinner={spinning}
            dataSource={dataSource || []}
            pagination={{
              onChange: (page) => {
                setPage(page);
              },
              pageSize: limit,
              total: count,
              current: page,
              showQuickJumper: true,
            }}
            activeFollowUpTab={activeFollowUpTab}
          />
        </TabPane>
        <TabPane tab={<span>Discarded</span>} key="3">
          <FollowUpTable
            spinner={spinning}
            dataSource={dataSource || []}
            pagination={{
              onChange: (page) => {
                setPage(page);
              },
              pageSize: limit,
              total: count,
              current: page,
              showQuickJumper: true,
            }}
            activeFollowUpTab={activeFollowUpTab}
          />
        </TabPane>
        <TabPane tab={<span>All</span>} key="4">
          <FollowUpTable
            spinner={spinning}
            dataSource={dataSource || []}
            pagination={{
              onChange: (page) => {
                setPage(page);
              },
              pageSize: limit,
              total: count,
              current: page,
              showQuickJumper: true,
            }}
            activeFollowUpTab={activeFollowUpTab}
          />
        </TabPane>
      </Tabs>
    </div>
  );
}

export default FollowUpHomePage;
